const schema = {
  __schema: {
    types: [
      {
        kind: "INTERFACE",
        name: "EventDefinition",
        possibleTypes: [
          {
            name: "Hero"
          }
        ]
      },
      {
        kind: "UNION",
        name: "BannerConfig",
        possibleTypes: [
          {
            name: "TextBannerConfig"
          },
          {
            name: "ImageBannerConfig"
          }
        ]
      },
      {
        kind: "INTERFACE",
        name: "IBanner",
        possibleTypes: [
          {
            name: "TextBannerConfig"
          },
          {
            name: "ImageBannerConfig"
          }
        ]
      },
      {
        kind: "UNION",
        name: "cibrQuoteOffer",
        possibleTypes: [
          {
            name: "cibrOffer"
          },
          {
            name: "cibrQuote"
          }
        ]
      },
      {
        kind: "UNION",
        name: "cicoQuoteOffer",
        possibleTypes: [
          {
            name: "cicoOffer"
          },
          {
            name: "cicoQuote"
          }
        ]
      }
    ]
  }
};

export default schema;
